import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const portalRoot = document.body;

export const DropdownPortal = ({ open, targetRef, children }) => {
  const [position, setPosition] = useState(null);

  // useLayoutEffect runs synchronously after DOM mutations but before paint
  useLayoutEffect(() => {
    if (open && targetRef?.current) {
      const updatePosition = () => {
        const rect = targetRef.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom + window.scrollY + 2,
          left: rect.left + window.scrollX,
          width: rect.width,
        });
      };

      updatePosition();
      
      // Update position on window resize prevent detaching
      window.addEventListener('resize', updatePosition);
      window.addEventListener('scroll', updatePosition, true);

      return () => {
        window.removeEventListener('resize', updatePosition);
        window.removeEventListener('scroll', updatePosition, true);
      };
    }
  }, [open, targetRef]);

  if (!open || !targetRef?.current) return null;

  return createPortal(
    <div
      style={{
        position: 'absolute',
        top: position ? `${position.top}px` : '-9999px',
        left: position ? `${position.left}px` : '-9999px',
        width: position ? `${position.width}px` : 'auto',
        zIndex: 99999,
        pointerEvents: 'auto',
      }}
    >
      {children}
    </div>,
    portalRoot
  );
};
